export const PASSWORD_RULES = [
  { key: "len", label: "At least 10 characters", test: (p) => p.length >= 10 },
  { key: "lower", label: "A lowercase letter", test: (p) => /[a-z]/.test(p) },
  { key: "upper", label: "An uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { key: "digit", label: "A number", test: (p) => /\d/.test(p) },
  { key: "special", label: "A special character (! @ # $ %…)", test: (p) => /[^A-Za-z0-9\s]/.test(p) },
];

export const passwordError = (pw) => {
  const miss = PASSWORD_RULES.find((r) => !r.test(pw || ""));
  return miss ? `Password needs: ${miss.label.toLowerCase()}` : null;
};
